import React from 'react';
import { HelpTooltip } from './HelpTooltip';
import { wt } from './widgetTokens';

interface SelectOption {
  value: any;
  label: string;
}

interface SelectWidgetProps {
  label: string;
  value: any;
  onChange: (value: any) => void;
  options: SelectOption[];
  error?: string;
  disabled?: boolean;
  required?: boolean;
  description?: string;
  helpText?: string;
}

export const SelectWidget: React.FC<SelectWidgetProps> = ({
  label,
  value,
  onChange,
  options,
  error,
  disabled = false,
  required = false,
  description,
  helpText
}) => {
  return (
    <div className={wt.container}>
      <div className={wt.labelRow}>
        <label className={wt.label} htmlFor={`select-${label}`}>
          {label}
          {required && <span className={wt.required}>*</span>}
        </label>
        {helpText && <HelpTooltip helpText={helpText} />}
      </div>
      {description && <p className={wt.description}>{description}</p>}
      <select
        id={`select-${label}`}
        value={value ?? ''}
        onChange={(e) => {
          const option = options.find(opt => String(opt.value) === e.target.value);
          onChange(option ? option.value : e.target.value);
        }}
        disabled={disabled}
        className={`${wt.select} ${error ? wt.inputError : ''}`}
      >
        {!value && <option value="">— Select —</option>}
        {options.map((option, index) => (
          <option key={index} value={String(option.value)}>{option.label}</option>
        ))}
      </select>
      {error && <p className={wt.errorMsg}>{error}</p>}
    </div>
  );
};

export default SelectWidget;
